/**
 * TanStack Query hooks for `publisher-performance-report`.
 * Provides rollup + drill queries (drill is lazy-enabled per affiliate row expansion).
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	publisherRollup,
	publisherDrill,
	publisherPerformanceReportQueryKeys,
	type RollupArgs,
	type RollupResponse,
	type DrillArgs,
	type DrillResponse,
} from "./api";

export function usePublisherRollup(
	args: RollupArgs,
): UseQueryResult<RollupResponse, Error> {
	return useQuery({
		queryKey: publisherPerformanceReportQueryKeys.rollup(args),
		queryFn: () => publisherRollup(args),
	});
}

export function usePublisherDrill(
	args: DrillArgs,
	enabled: boolean,
): UseQueryResult<DrillResponse, Error> {
	return useQuery({
		queryKey: publisherPerformanceReportQueryKeys.drill(args),
		queryFn: () => publisherDrill(args),
		enabled: enabled && Boolean(args.affiliateId),
	});
}
